import React from 'react';
import { IconBase, IconProps } from '../IconBase';

export const SearchIcon = ({ size, color, title, decorative, ...restItems }: IconProps) => (
	<IconBase viewBox="0 0 20 20" size={size} color={color} title={title} decorative={decorative} {...restItems}>
		<path
			d="M13.0625 8.4375C13.0625 6.87891 12.2148 5.45703 10.875 4.66406C9.50781 3.87109 7.83984 3.87109 6.5 4.66406C5.13281 5.45703 4.3125 6.87891 4.3125 8.4375C4.3125 10.0234 5.13281 11.4453 6.5 12.2383C7.83984 13.0312 9.50781 13.0312 10.875 12.2383C12.2148 11.4453 13.0625 10.0234 13.0625 8.4375ZM12.2148 12.9219C11.2305 13.6875 10 14.125 8.6875 14.125C5.54297 14.125 3 11.582 3 8.4375C3 5.32031 5.54297 2.75 8.6875 2.75C11.8047 2.75 14.375 5.32031 14.375 8.4375C14.375 9.77734 13.9102 11.0078 13.1445 11.9922L16.8086 15.6289C17.0547 15.9023 17.0547 16.3125 16.8086 16.5586C16.5352 16.832 16.125 16.832 15.8789 16.5586L12.2148 12.9219Z"
			fill="#62615F"
		/>
	</IconBase>
);
